import React from 'react'
import video from "./videos/world-inovation.mp4";
import {  Hero,
    Container,
    Wrapper,
    Info,
    Info1,
  Info2,
  Wish,
  WishHeader,
  WishDesc,
  WishFooter,
} from "./MyWishStyle"


function MyWish() {
        

    return (
      <Container>
        <Wish>
                <WishHeader>My wish for you</WishHeader>
                <WishDesc>Birthdays are generally celebrated once a year on the exact day of birth that is the sole reason why am celebrating this special birthday of mine in such fascinating way as a software developer. I wish myself an unforgettable, prosperous birthday with long life, more accomplishment in good health, favour, unlimited grace and these are my wishes for you too that have taken some minute of you time to wish me well.<br/>Have a wonderful xmas and prosperous new year.<br/>See you in 2023.</WishDesc>
                <WishFooter>Hip! Hip!! Hip!!! Hurray</WishFooter>
            </Wish>
          <Hero src={video} type="video/mp4" autoPlay loop playsInline muted />
          {/* <Hero src={video} type="video/mp4" autoPlay={true} loop={true} playsInline muted /> */}
          <Wrapper>
            <Info>Wishing You All </Info>
            <Info1>Happy XMAS</Info1>
            <Info2>In Advance</Info2>
          </Wrapper>
        </Container>
    )
}

export default MyWish
